import script from "./AmplifyTopicImport.vue?vue&type=script&setup=true&lang=js"
export * from "./AmplifyTopicImport.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5833f94f"]])

export default __exports__